var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"theme-toggle",class:{ 'theme-toggle--workspace': _vm.$route.path !== '/' && _vm.$route.path !== '/login' },attrs:{"type":"button","aria-label":_vm.toggleLabel,"title":_vm.toggleLabel},on:{"click":_vm.toggleTheme}},[_c('i',{class:_vm.themeIcon,attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }